// Baseroutes
export const PAGE = "/:slug?";

// Meta Routes
export const IMPRINT = "/imprint";
export const PRIVACY = "/privacy";

// Base URL
export const { REACT_APP_BASE_URL } = process.env;
